import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

const HEIGHTS = { sm: 24, md: 32, lg: 40, xl: 56 };

export default function Logo({ size = "md", showWordmark = true }) {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  // Until we know the theme, render without a filter to avoid a dark-mode flash.
  const invert = mounted && resolvedTheme === "dark";
  const h = HEIGHTS[size] || HEIGHTS.md;

  return (
    <div className="flex items-center gap-2 select-none" data-testid="sisyphean-logo">
      <img
        src="/brand/sisyphean-logo.svg"
        alt="Sisyphean"
        height={h}
        style={{
          height: `${h}px`,
          width: "auto",
          // The provided SVG is black; flip to white in dark mode.
          filter: invert ? "invert(1)" : "none",
          // Ensure crisp rendering at small sizes.
          imageRendering: "auto",
        }}
        draggable={false}
      />
      {showWordmark && (
        <span
          className="serif-mod tracking-[-0.02em] leading-none"
          style={{
            fontWeight: 500,
            fontSize: size === "sm" ? "1rem" : size === "lg" ? "1.5rem" : size === "xl" ? "2rem" : "1.25rem",
          }}
        >
          Sisyphean
        </span>
      )}
    </div>
  );
}
